import React from 'react'
import styled from 'styled-components'
import { connect } from 'react-redux'
import { ErrorIcon } from '../assets/icons'
import { clearFlashMessage } from '../actions'
import Modal from './Modal'
import { Button } from './ui/button'
import { Text1 } from '../styles/generics'

const ApiErrorMessage = props =>
	props.flashMessage.message ? (
		<Modal>
			<Container>
				<ErrorIcon />
				<Text1>{props.flashMessage.message}</Text1>
				<Button label="Cerrar" $variant="primary" onClick={props.clearFlashMessage} />
			</Container>
		</Modal>
	) : null

const mapDispatchToProps = { clearFlashMessage }
function mapStateToProps({ flashMessage }) {
	return { flashMessage }
}
export default connect(mapStateToProps, mapDispatchToProps)(ApiErrorMessage)

const Container = styled.div`
	display: flex;
	text-align: center;
	flex-direction: column;
	align-items: center;
	padding: 20px;
	font-size: 24px;
	background: ${props => props.theme.colors.brand.white};
	color: ${props => props.theme.colors.feedback.error};
	width: 100%;
	border-radius: 25px;
	gap: 12px;
	@media (min-width: ${props => props.theme.sizes.breakPoints.small}) {
		¡display: flex;
		text-align: center;
		flex-direction: column;
		align-items: center;
	}

	> i {
		font-size: 60px;
		margin-bottom: 20px;
	}
`
